module.exports = __webpack_public_path__ + "img/emo_34.21ed3c01.gif";